import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';

import ScrollToTop from './services/Utils';
import MainLayout from './layouts/Main.js';
import PrivateRoute from './private';

const queryClient = new QueryClient();
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop />
    <QueryClientProvider client={queryClient}>
      <Switch>
        <PrivateRoute path={'/'} component={MainLayout} />
      </Switch>
    </QueryClientProvider>
  </BrowserRouter>,
  document.getElementById('root')
);